const Auth = {
  aws_project_region: 'eu-west-3',
  aws_cognito_region: 'eu-west-3',
  aws_user_pools_id: 'eu-west-3_PHqSfM3hO',
  aws_user_pools_web_client_id: '19oe5f06n7sgrnjigohea8goci',
}


export default Auth
